module.exports = __webpack_public_path__ + "static/media/logo_new_2.907e546e.png";


//////////////////
// WEBPACK FOOTER
// ./src/component/img/logo_new_2.png
// module id = 966
// module chunks = 2